// file to base 64

export function fileToBase64(file) {
  return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(){
        resolve(reader.result);
      };
  })
}

export function downloadFile(blobOrUrl) {
  if (blobOrUrl != null && navigator.msSaveBlob && typeof blobOrUrl !== 'string') {
    navigator.msSaveBlob(blobOrUrl, 'file');
    return;
  }
  const link = document.createElement('a');
  if (typeof blobOrUrl === 'string') {
    link.href = blobOrUrl;
  } else {
    link.href = window.URL.createObjectURL(blobOrUrl);
  }
  link.setAttribute('download', 'file');
  document.body.appendChild(link);
  link.click();
  if (typeof blobOrUrl !== 'string') {
    window.URL.revokeObjectURL(link.href);
  }
  document.body.removeChild(link);
}

export function copyArrParam(array, params) {
  let value;
  if (array) {
    array.forEach(item => {
      for (const key of Object.keys(params)) {
        value = item[params[key]] || item[key];
        item[params[key]] = value;
        item[key] = value;
      }
    });
  }
  return array;
}